import IAddress from '../../server/src/Interfaces/IAddress'

export const MAX_FIREPLACES_PER_TYPE = 1000

export const setFireplaceCount = (
    selected: IAddress['selectedFireplaceIds'],
    id: number,
    count: number
): IAddress['selectedFireplaceIds'] => {
    const nextCount = Math.max(0, Math.min(MAX_FIREPLACES_PER_TYPE, Math.trunc(count)))

    if (nextCount === 0) {
        return selected.filter(item => item.id !== id)
    }

    if (selected.some(item => item.id === id)) {
        return selected.map(item => item.id === id ? { ...item, count: nextCount } : item)
    }

    return [...selected, { id, count: nextCount }]
}
